import Plotly from "plotly.js-dist";

const CHART_IMAGE_SIZE = { width: 1200, height: 700 };
const CHART_IMAGE_MARGIN = { l: 70, r: 40, t: 70, b: 60 };

const INVALID_FILE_NAME_CHARS = /[\\/:*?"<>|\u0000-\u001f]+/g;

const toFileNamePart = (value) => String(value ?? "")
    .replace(INVALID_FILE_NAME_CHARS, " ")
    .trim()
    .replace(/\s+/g, "_")
    .slice(0, 80);

// e.g. "Top_BCOs_by_accept_rate_Q2_chart_1" for the first chart of the chat's second answer.
export function chatAttachmentFileName(chatName, key, kind, index) {
    const parts = [toFileNamePart(chatName) || "Chat"];
    if (key !== undefined && key !== null && key !== "") {
        parts.push(`Q${key}`);
    }
    parts.push(kind, index);
    return parts.join("_");
}

// Accepts a plotly figure json ({ data, layout, config }), a bare list of traces, or the json
// string of either as it comes back from the DB. Returns a deep copy since plotly mutates its inputs.
export function parsePlotlyFigure(chartData) {
    const raw = typeof chartData === "string" ? JSON.parse(chartData) : chartData;
    const figure = JSON.parse(JSON.stringify(raw));

    if (Array.isArray(figure)) {
        return { data: figure, layout: {}, config: {} };
    }

    const { data = [], layout = {}, config = {} } = figure || {};
    return { data: Array.isArray(data) ? data : [data], layout, config };
}

export function downloadChartImage(chartData, fileName) {
    const { data, layout } = parsePlotlyFigure(chartData);
    const title = typeof layout.title === "string" ? { text: layout.title } : layout.title;

    const exportLayout = {
        ...layout,
        width: CHART_IMAGE_SIZE.width,
        height: CHART_IMAGE_SIZE.height,
        margin: { ...CHART_IMAGE_MARGIN, ...(layout.margin || {}) },
        font: { size: 13, ...(layout.font || {}) },
        paper_bgcolor: layout.paper_bgcolor || "#ffffff",
        ...(title ? { title: { ...title, font: { size: 18, ...(title.font || {}) } } } : {}),
    };

    // Plotly appends the extension to the filename itself.
    return Plotly.downloadImage({ data, layout: exportLayout }, {
        format: "png",
        filename: fileName,
        ...CHART_IMAGE_SIZE,
    });
}

const toCsvCell = (value) => {
    if (value === null || value === undefined) return "";
    const text = typeof value === "object" ? JSON.stringify(value) : String(value);
    return /[",\r\n]|^\s|\s$/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function downloadCsv(columns, rows, fileName) {
    const lines = [
        columns.map(toCsvCell).join(","),
        ...rows.map((row) => columns.map((column) => toCsvCell(row?.[column])).join(",")),
    ];
    // The BOM makes Excel read the file as UTF-8 instead of the system code page.
    const blob = new Blob(["\ufeff" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
